import { useMutation } from "@tanstack/react-query";
import {
  importMatchEvents,
  ImportedEventBundle,
  ImportMatchEventsPayload
} from "@/api/matches";

// Only injects into form state — the DB is NOT touched yet, so no
// invalidate is needed. Once the user hits Save the manualUpdate
// mutation already invalidates the FullMatches query.
export const useImportMatchEvents = () => {
  return useMutation<ImportedEventBundle, Error, { matchId: string; url: string }>({
    mutationFn: ({ matchId, url }) => {
      const payload: ImportMatchEventsPayload = { url };
      return importMatchEvents(matchId, payload);
    }
  });
};
